import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-54a95347"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "santa-hat-container"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"christmas-lights\" data-v-54a95347><span class=\"light light-1\" data-v-54a95347></span><span class=\"light light-2\" data-v-54a95347></span><span class=\"light light-3\" data-v-54a95347></span><span class=\"light light-4\" data-v-54a95347></span><span class=\"light light-5\" data-v-54a95347></span><span class=\"light light-6\" data-v-54a95347></span></div><div class=\"santa-hat\" data-v-54a95347>🎅</div><div class=\"christmas-lights\" data-v-54a95347><span class=\"light light-7\" data-v-54a95347></span><span class=\"light light-8\" data-v-54a95347></span><span class=\"light light-9\" data-v-54a95347></span><span class=\"light light-10\" data-v-54a95347></span><span class=\"light light-11\" data-v-54a95347></span><span class=\"light light-12\" data-v-54a95347></span></div>", 3)
const _hoisted_6 = [
  _hoisted_3
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"margin":"0"} }, "Печать заказ-наряда")
], -1))
const _hoisted_8 = { class: "print-content-container" }
const _hoisted_9 = ["srcdoc"]
const _hoisted_10 = {
  key: 1,
  class: "error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Printer = _resolveComponent("Printer")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _ctx.onPrintClick,
      disabled: !_ctx.orderId || _ctx.loading,
      class: _normalizeClass({ 'icon-only': _ctx.iconOnly })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_Printer)
          ]),
          _: 1
        }),
        (!_ctx.iconOnly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, " Печать"))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onClick", "disabled", "class"]),
    (_ctx.showSantaHat)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.modalVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalVisible) = $event)),
      onClosed: _ctx.onModalClosed,
      width: "600px",
      "close-on-click-modal": false,
      "close-on-press-escape": true,
      "append-to-body": "",
      class: "print-dialog"
    }, {
      header: _withCtx(() => [
        _hoisted_7
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            disabled: !_ctx.printFormContent,
            type: "primary",
            onClick: _ctx.onPrintButtonClick,
            style: {"margin":".6 0 1rem"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Printer)
                ]),
                _: 1
              }),
              _createTextVNode("  Печать ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          (_ctx.printFormContent)
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                class: "print-preview",
                srcdoc: _ctx.printFormContent,
                sandbox: "allow-same-origin",
                ref: "previewIframe"
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_el_alert, {
                  title: "Ошибка загрузки печатной формы",
                  description: _ctx.error,
                  type: "error",
                  closable: false
                }, null, 8, ["description"])
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClosed"])
  ], 64))
}